import request from "./request.js";
export function SkuList(params) {
    return request({
        url: '/api/Sku/List',
        method: 'get',
        params
    })
}
export function StrategyList(params) {
    return request({
        url: '/api/Strategy/List',
        method: 'get',
        params
    })
}
export function OrderList (params) {
    return request({
        url: '/api/Order/List',
        method: 'get',
        params
    })
}
export function StrategySkuList(params) {
    return request({
        url: '/api/StrategySku/List',
        method: 'get',
        params
    })
}
export function SkuSearch(params) {
    return request({
        url: '/api/Sku/Search',
        method: 'get',
        params
    })
}
export function BannerList(params) {
    return request({
        url: '/api/Banner/List',
        method: 'get',
        params
    })
}
export const SkuEdit = (data) => request({ method: 'post', url: '/api/Sku/Edit', data: data })
export const StrategyEdit = (data) => request({ method: 'post', url: '/api/Strategy/Edit', data: data })
export const StrategyRemove = (params) => request({ method: 'post', url: '/api/Strategy/Remove', params: params })
export const StrategySkuEdit = (data) => request({ method: 'post', url: '/api/StrategySku/Edit', data: data })
export const BannerEdit = (data) => request({ method: 'post', url: '/api/Banner/Edit', data: data })
export const BannerAdd = (data) => request({ method: 'post', url: '/api/Banner/Add', data: data })
export const BannerRemove = (params) => request({ method: 'post', url: '/api/Banner/Remove', params: params })
export const OrderEdit = (data) => request({ method: 'post', url: '/api/Order/Edit', data: data })


